document.addEventListener('DOMContentLoaded', function () {


    // --- Tabbify JS ---
    const tabs = document.querySelectorAll('.tabbify__tab');
    const tabContents = document.querySelectorAll('.tabbify__tab-content');

    if (tabs.length > 0 && tabContents.length > 0) {
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // Remove active from all tabs
                tabs.forEach(t => t.classList.remove('active'));
                tabContents.forEach(c => {
                    c.style.display = 'none';
                    c.classList.remove('active');
                });

                // Add active to clicked
                tab.classList.add('active');
                const targetTab = tab.getAttribute('data-tab');
                const targetContent = document.querySelector(`.tabbify__tab-content[data-tab="${targetTab}"]`);
                if (targetContent) {
                    targetContent.classList.add('active');
                    targetContent.style.display = 'block';
                }
            });
        });
    }

    // Fallback slideToggle utility in case it was accidentally deleted 
    // or isn't defined globally, required to make the accordions function without relying on jQuery
    if (typeof window.slideToggle === 'undefined') {
        window.slideUp = (target, duration = 300) => {
            target.style.transitionProperty = 'height, margin, padding';
            target.style.transitionDuration = duration + 'ms';
            target.style.boxSizing = 'border-box';
            target.style.height = target.offsetHeight + 'px';
            target.offsetHeight;
            target.style.overflow = 'hidden';
            target.style.height = 0;
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            window.setTimeout(() => {
                target.style.display = 'none';
                target.style.removeProperty('height');
                target.style.removeProperty('padding-top');
                target.style.removeProperty('padding-bottom');
                target.style.removeProperty('margin-top');
                target.style.removeProperty('margin-bottom');
                target.style.removeProperty('overflow');
                target.style.removeProperty('transition-duration');
                target.style.removeProperty('transition-property');
            }, duration);
        };

        window.slideDown = (target, duration = 300) => {
            target.style.removeProperty('display');
            let display = window.getComputedStyle(target).display;
            if (display === 'none') display = 'block';
            target.style.display = display;
            let height = target.offsetHeight;
            target.style.overflow = 'hidden';
            target.style.height = 0;
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            target.offsetHeight;
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.height = height + 'px';
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            window.setTimeout(() => {
                target.style.removeProperty('height');
                target.style.removeProperty('overflow');
                target.style.removeProperty('transition-duration');
                target.style.removeProperty('transition-property');
            }, duration);
        };

        window.slideToggle = (target, duration = 300) => {
            if (window.getComputedStyle(target).display === 'none') {
                return window.slideDown(target, duration);
            } else {
                return window.slideUp(target, duration);
            }
        };
    }

    // --- FAQ Accordion JS ---
    const faqQuestions = document.querySelectorAll('.faq-question');

    if (faqQuestions.length > 0) {
        faqQuestions.forEach(question => {
            question.addEventListener('click', () => {
                const answer = question.nextElementSibling;
                if (!answer) return;

                const svg = question.querySelector('svg');
                const isClosed = window.getComputedStyle(answer).display === 'none';

                window.slideToggle(answer);

                if (isClosed) {
                    if (svg) svg.style.transform = 'scale(1)'; // reset flip to open
                } else {
                    if (svg) svg.style.transform = 'scale(-1)'; // flip back to close
                }
            });
        });
    }

    // --- SEE FULL BENEFITS button Smooth Open ---
    const fullBenefitsBtn = document.querySelector('.full-benefits-btn');
    const accordionInfo = document.querySelector('.tabbify__tab-content-accordion-info');

    if (fullBenefitsBtn && accordionInfo) {
        // Hide initially
        accordionInfo.style.display = 'none';

        fullBenefitsBtn.addEventListener('click', () => {
            const isClosed = window.getComputedStyle(accordionInfo).display === 'none';
            window.slideToggle(accordionInfo);

            const svg = fullBenefitsBtn.querySelector('svg');
            // find the text node to update text safely without removing SVG
            let textNode = Array.from(fullBenefitsBtn.childNodes).find(n => n.nodeType === 3 && n.textContent.trim() !== '');

            if (isClosed) {
                if (svg) svg.style.transform = 'rotate(180deg)';
                if (textNode) textNode.nodeValue = 'HIDE DETAILS';
            } else {
                if (svg) svg.style.transform = 'rotate(0deg)';
                if (textNode) textNode.nodeValue = 'SEE FULL BENEFITS + ';
            }
        });
    }

    const thumbSwiperElement = document.querySelector('.livyond-product-media-gallery__thumbnails');
    let thumbSwiper; // declare outside to allow mainSwiper to access it

    if (thumbSwiperElement) {
        thumbSwiper = new Swiper('.livyond-product-media-gallery__thumbnails', {
            direction: 'vertical',
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    direction: 'horizontal',
                    slidesPerView: 5,
                },
                750: {
                    direction: 'vertical',
                    slidesPerView: 7,
                }
            }
        });
    }

    const mainSwiperElement = document.querySelector('.livyond-product-media-gallery__media');
    if (mainSwiperElement) {
        var mainSwiperOptions = {
            direction: 'horizontal',
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: '.livyond-product-media-arrow.swiper-button-next',
                prevEl: '.livyond-product-media-arrow.swiper-button-prev',
            },
            pagination: {
                el: '.livyond-product-media-pagination .swiper-pagination',
                clickable: true,
            }
        };

        // Only attach thumbs if the thumbnail Swiper successfully initialized
        if (thumbSwiper) {
            mainSwiperOptions.thumbs = { swiper: thumbSwiper };
        }

        var mainSwiper = new Swiper('.livyond-product-media-gallery__media', mainSwiperOptions);

        // --- Video Logic ---
        mainSwiper.on('slideChange', function () {
            // Pause all videos in the gallery
            const videos = mainSwiperElement.querySelectorAll('video');
            videos.forEach(video => {
                video.pause();
            });

            // Play active slide video
            const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
            if (activeSlide) {
                const activeVideo = activeSlide.querySelector('video');
                if (activeVideo) {
                    activeVideo.muted = false;
                    activeVideo.play();
                }
            }
        });

        // Click to pause/play logic
        const allVideos = mainSwiperElement.querySelectorAll('video');
        allVideos.forEach(video => {
            video.addEventListener('click', function (e) {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        });

        // Ensure first slide video plays on load if it has a video
        setTimeout(() => {
            const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
            if (activeSlide) {
                const activeVideo = activeSlide.querySelector('video');
                if (activeVideo) {
                    activeVideo.muted = false;
                    activeVideo.play();
                }
            }
        }, 100);
    }

    // --- Info Popup JS ---
    const popupTriggers = document.querySelectorAll('[data-popup-target]');
    const popups = document.querySelectorAll('.info-popup-model');
    const closeButtons = document.querySelectorAll('.info-popup-model-close');

    if (popupTriggers.length > 0) {
        popupTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const targetId = trigger.getAttribute('data-popup-target');
                // Target the element by ID
                const targetPopup = document.getElementById(targetId);
                if (targetPopup) {
                    targetPopup.classList.add('active');
                    document.body.classList.add('active-popup');
                }
            });
        });

        closeButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const popup = btn.closest('.info-popup-model');
                if (popup) {
                    popup.classList.remove('active');
                    document.body.classList.remove('active-popup');
                }
            });
        });

        // Close popup when clicking on the overlay background
        popups.forEach(popup => {
            popup.addEventListener('click', (e) => {
                if (e.target === popup) {
                    popup.classList.remove('active');
                    document.body.classList.remove('active-popup');
                }
            });
        });
    }

    // --- Media Zoom JS ---
    const mediaZoomBtns = document.querySelectorAll('.media-zoom');
    const mediaZoomModal = document.querySelector('.media-zoom-modal');
    const mediaZoomCloseBtn = document.querySelector('.media-zoom-modal__close');
    const mediaZoomModalMedia = document.querySelector('.media-zoom-modal__media');

    if (mediaZoomBtns.length > 0 && mediaZoomModal && mediaZoomModalMedia) {
        mediaZoomBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                // Find nearest gallery container to get the active slide
                const galleryContainer = btn.closest('.livyond-product-media-gallery__media');
                if (galleryContainer) {
                    const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
                    if (activeSlide) {
                        const mediaElement = activeSlide.querySelector('img, video, iframe, model-viewer');
                        if (mediaElement) {
                            // Clear existing modal content
                            mediaZoomModalMedia.innerHTML = '';

                            // Clone the media element to show in modal
                            const clonedElement = mediaElement.cloneNode(true);
                            if (clonedElement.tagName.toLowerCase() === 'video') {
                                clonedElement.controls = true;
                                clonedElement.muted = false;
                            }
                            mediaZoomModalMedia.appendChild(clonedElement);
                        }
                    }
                }

                mediaZoomModal.classList.add('active');
                document.body.classList.add('active-popup');
            });
        });

        if (mediaZoomCloseBtn) {
            mediaZoomCloseBtn.addEventListener('click', () => {
                mediaZoomModal.classList.remove('active');
                document.body.classList.remove('active-popup');
                mediaZoomModalMedia.innerHTML = ''; // Clear to stop videos
            });
        }

        // Close popup when clicking on the overlay background
        mediaZoomModal.addEventListener('click', (e) => {
            if (e.target === mediaZoomModal) {
                mediaZoomModal.classList.remove('active');
                document.body.classList.remove('active-popup');
                mediaZoomModalMedia.innerHTML = ''; // Clear to stop videos 
            }
        });
    }

    // --- Product Bundle JS ---
    const bundleGrid = document.querySelector('.products-bundle-grid');
    if (bundleGrid) {
        const bundleProducts = bundleGrid.querySelectorAll('.product');
        const comparePriceEl = document.querySelector('.bundle-total .compare-price');
        const priceEl = document.querySelector('.bundle-total .price');
        const discountEl = document.querySelector('.bundle-total .discount');
        const discountPercent = parseFloat(discountEl?.getAttribute('data-discount') || 0);

        function updateBundlePrice() {
            let totalComparePrice = 0;
            const selectedItems = [];

            bundleProducts.forEach(product => {
                if (product.classList.contains('selected')) {
                    totalComparePrice += parseFloat(product.getAttribute('data-product-price'));
                    selectedItems.push(product.getAttribute('data-variant-id'));
                }
            });

            // Simple formatting for Shopify - assuming dollars
            const formatMoney = (amount) => {
                return '$' + (amount / 100).toFixed(2);
            };

            if (selectedItems.length === 0) {
                if (comparePriceEl) comparePriceEl.textContent = '';
                if (priceEl) priceEl.textContent = '';
                if (discountEl) discountEl.textContent = '';
                return;
            }

            if (selectedItems.length === 1) {
                if (comparePriceEl) comparePriceEl.textContent = '';
                if (priceEl) priceEl.textContent = formatMoney(totalComparePrice);
                if (discountEl) discountEl.textContent = '';
                return;
            }

            const discountAmount = (totalComparePrice * discountPercent) / 100;
            const finalPrice = totalComparePrice - discountAmount;

            if (comparePriceEl) comparePriceEl.textContent = formatMoney(totalComparePrice);
            if (priceEl) priceEl.textContent = formatMoney(finalPrice);
            if (discountEl) {
                if (discountPercent > 0) {
                    discountEl.textContent = `(save ${formatMoney(discountAmount)})`;
                } else {
                    discountEl.textContent = '';
                }
            }
        }

        bundleProducts.forEach(product => {
            product.addEventListener('click', () => {
                product.classList.toggle('selected');
                updateBundlePrice();
            });
        });

        // Initialize on load
        updateBundlePrice();

        // Add to Cart Logic
        const addToCartBtn = document.querySelector('.block__livyond-product-bundle .add-to-cart');
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', () => {
                const items = [];
                bundleGrid.querySelectorAll('.product.selected').forEach(selected => {
                    items.push({
                        id: selected.getAttribute('data-variant-id'),
                        quantity: 1
                    });
                });

                if (items.length > 0) {
                    const originalText = addToCartBtn.textContent;
                    addToCartBtn.textContent = 'Adding...';
                    addToCartBtn.disabled = true;

                    // Request cart-ajax section to update the drawer correctly
                    const body = {
                        items: items,
                        sections: ['cart-ajax']
                    };

                    fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(body)
                    })
                        .then(response => {
                            if (!response.ok) throw new Error('Failed to add to cart');
                            return response.json();
                        })
                        .then(data => {
                            // Find the events to trigger the theme's cart drawer
                            const eventDetail = {
                                product: data,
                                preventCartOpen: false
                            };

                            // Dispatch standard theme event if available
                            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                                bubbles: true,
                                detail: eventDetail
                            }));

                            // Redirect as fallback if drawer doesn't open, or just reset button
                            addToCartBtn.textContent = 'Added!';
                            setTimeout(() => {
                                addToCartBtn.textContent = originalText;
                                addToCartBtn.disabled = false;
                            }, 2000);
                        })
                        .catch(error => {
                            console.error('Error adding to cart:', error);
                            addToCartBtn.textContent = originalText;
                            addToCartBtn.disabled = false;
                        });
                }
            });
        }
    }

});
